
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-agents",
      function () {
        return require("private-next-pages/real-estate-agents.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-agents"])
      });
    }
  